import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "remixicon/fonts/remixicon.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store"; // ✅ Import persistor from store
import * as Sentry from "@sentry/react";
import { PersistGate } from "redux-persist/integration/react";
// ❌ REMOVED: import { persistStore } from "redux-persist";
import { BrowserRouter as Router } from "react-router-dom";
import { Logger } from './utils/logger';

Sentry.init({
  dsn: "https://0b18e9e9f9cc45d3879f03b965c5ca20@o4504090766934016.ingest.sentry.io/4504090793738240",
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 0.05,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// ❌ REMOVED: let persistor = persistStore(store);
// ✅ Now using persistor imported from store.tsx

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);

reportWebVitals();